interface Props {
  name: string;
  color: string;
}

export function SubscriptionStatusBadge({ name, color }: Props) {
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold text-white"
      style={{ backgroundColor: color }}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-white/70 shrink-0" />
      {name}
    </span>
  );
}
